// extracted by mini-css-extract-plugin
module.exports = {"Container":"ExpandableCaption_Container__IUErR"};